'use client'

import { FormattedNumber } from 'react-intl'

import { CurrencyStringDollars } from '@b-stock/fe-core/bstock-react'

type FormatProps = {
  lower: number | null
  upper: number | null
}

type CurrencyFormatProps = FormatProps & {
  currency: string
}

const IntegerFormat = ({ lower, upper }: FormatProps) =>
  upper ? (
    <>
      <FormattedNumber value={lower || 0} />
      {' - '}
      <FormattedNumber value={upper || 0} />
    </>
  ) : (
    <>
      <FormattedNumber value={lower || 0} />+
    </>
  )

const CurrencyFormat = ({ lower, upper, currency }: CurrencyFormatProps) =>
  upper ? (
    <>
      <CurrencyStringDollars
        value={lower || 0}
        currency={currency}
        omitDecimal
      />
      {' - '}
      <CurrencyStringDollars
        value={upper || 0}
        currency={currency}
        omitDecimal
      />
    </>
  ) : (
    <>
      <CurrencyStringDollars
        value={lower || 0}
        currency={currency}
        omitDecimal
      />
      +
    </>
  )

export { IntegerFormat, CurrencyFormat }
